import { createCustomPaginatedQueryOptions } from "../shared/createCustomPaginatedQueryOptions";
import { listProductInfos } from "@/graphql/queries";
import { ProductInfo } from "@/types/AppTypes";

export const fetchCustomPaginatedProductsQueryOptions = (
  filters: Record<string, any> = {},
  limit = 10,
  options = {}
) =>
  createCustomPaginatedQueryOptions<ProductInfo>({
    queryKey: ["products", filters], 
    graphqlQuery: listProductInfos,
    getVariables: (pageParam) => ({
      limit,
      nextToken: pageParam,
      filter:{
        ...filters,
        is_deleted: {
          eq: false,
        },
        is_active: {
          eq: true,
        },
      }
     
    }),
    options:{
      ...options,
    },
  });
